/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Jobs_Placeholder_SalaryInputs */

const en_jobs_placeholder_salary = /** @type {(inputs: Jobs_Placeholder_SalaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`e.g. ${i?.amount}`)
};

const de_jobs_placeholder_salary = /** @type {(inputs: Jobs_Placeholder_SalaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`z.B. ${i?.amount}`)
};

const fr_jobs_placeholder_salary = /** @type {(inputs: Jobs_Placeholder_SalaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ex. ${i?.amount}`)
};

const es_jobs_placeholder_salary = /** @type {(inputs: Jobs_Placeholder_SalaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ej. ${i?.amount}`)
};

const it_jobs_placeholder_salary = /** @type {(inputs: Jobs_Placeholder_SalaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`es. ${i?.amount}`)
};

const nl_jobs_placeholder_salary = /** @type {(inputs: Jobs_Placeholder_SalaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`bijv. ${i?.amount}`)
};

const pl_jobs_placeholder_salary = /** @type {(inputs: Jobs_Placeholder_SalaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`np. ${i?.amount}`)
};

const fi_jobs_placeholder_salary = /** @type {(inputs: Jobs_Placeholder_SalaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`esim. ${i?.amount}`)
};

const da_jobs_placeholder_salary = /** @type {(inputs: Jobs_Placeholder_SalaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`f.eks. ${i?.amount}`)
};

const sv_jobs_placeholder_salary = /** @type {(inputs: Jobs_Placeholder_SalaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`t.ex. ${i?.amount}`)
};

/**
* | output |
* | --- |
* | "e.g. {amount}" |
*
* @param {Jobs_Placeholder_SalaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_placeholder_salary = /** @type {((inputs: Jobs_Placeholder_SalaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Placeholder_SalaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_placeholder_salary(inputs)
	if (locale === "fr") return fr_jobs_placeholder_salary(inputs)
	if (locale === "es") return es_jobs_placeholder_salary(inputs)
	if (locale === "it") return it_jobs_placeholder_salary(inputs)
	if (locale === "nl") return nl_jobs_placeholder_salary(inputs)
	if (locale === "pl") return pl_jobs_placeholder_salary(inputs)
	if (locale === "fi") return fi_jobs_placeholder_salary(inputs)
	if (locale === "da") return da_jobs_placeholder_salary(inputs)
	if (locale === "sv") return sv_jobs_placeholder_salary(inputs)
	return en_jobs_placeholder_salary(inputs)
});